import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of, switchMap, tap, delay } from 'rxjs';
import * as userProfileFetchAction from '../action/fetch-userProfile.action';
import * as userPendingRequestAction from '../action/fetch-pendingRequest.action';
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import * as functionalityAction from '../action/user-profile-funcionality.action';
import { UserProfileEffectsService } from './user-profile.effects.service';
import { UserProfileService } from '../../services/user-profile.service';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { Router } from '@angular/router';
import { AppConstants } from '../../../../SGRE-shared/constants/app-constant';
import {
  FetchDataState,
  FetchedUpdatedState,
  PayloadForAccept,
  PayloadForSubmit,
} from '../user-profile.model';
import { pendingRequestState } from '../user-profile.state';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';
@Injectable()
export class UserProfileEffects {
  protected logger = inject(LoggerService);

  constructor(
    private actions: Actions,
    private apiService: ApiService,
    private userProfileEffectsService: UserProfileEffectsService,
    private userProfileService: UserProfileService,
    private globalService: GlobalService,
    private router: Router
  ) { }

  fetchUserPrfileData$ = createEffect(() =>
    this.actions.pipe(
      ofType(userProfileFetchAction.fetchUserProfileAction),
      switchMap((action) =>
        this.apiService.getUserProfileList(
          action.param,
          action.currentUserId
        )
      ),
      map((data: FetchDataState) => {
        const updatedData: FetchedUpdatedState =
          this.userProfileEffectsService.mapFetchdata(data);
        this.globalService.loadingSubject.next(false);
        return userProfileFetchAction.fetchUserProfileActionSuccess({
          profileData: updatedData,
        });
      }),
      catchError((error) =>
        of(
          userProfileFetchAction.fetchUserProfileActionFail({
            payload: tryNormalizeHttpError(error, this.logger),
          })
        )
      )
    )
  );

  fetchPendingRequestData$ = createEffect(() =>
    this.actions.pipe(
      ofType(userPendingRequestAction.fetchPendingRequestAction),
      switchMap((action) =>
        this.apiService.getPendingRequest(
          action.param1,
          action.param2,
          action.legalEntityId
        )
      ),
      map((data: pendingRequestState) => {
        return userPendingRequestAction.fetchPendingRequestActionSuccess({
          requestAccessPending: data,
        });
      }),
      catchError((error) =>
        of(
          userPendingRequestAction.fetchPendingRequestActionFail({
            payload: tryNormalizeHttpError(error, this.logger),
          })
        )
      )
    )
  );

  saveUserProfile$ = createEffect(() =>
    this.actions.pipe(
      ofType(functionalityAction.saveUserProfileAction),
      mergeMap((action) => {
        return this.userProfileEffectsService.getSubmitPayload(action.key).pipe(
          mergeMap((payload: PayloadForSubmit) => {
            return this.apiService
              .updateCustomer(
                payload.user,
                payload.sgreAdmin,
                payload.internal,
                payload.requestArray
              )
              .pipe(
                map((data) => {
                  this.userProfileService.fethUserProFileData();
                  return functionalityAction.saveUserProfileActionSuccess({
                    success: data.status,
                  });
                }),
                catchError((error) => {
                  this.globalService.loadingSubject.next(false); 
                  this.userProfileService.updateButtonFlag();
                  return of(
                    functionalityAction.saveUserProfileActionFail({
                      payload: tryNormalizeHttpError(error, this.logger),
                    })
                  );
                }
                )
              )
          })
        );
      })
    )
  );

  acceptPendingRequest$ = createEffect(() =>
    this.actions.pipe(
      ofType(functionalityAction.acceptPendingRequestAction),
      switchMap(() => {
        const payload: PayloadForAccept =
          this.userProfileEffectsService.getAcceptPayload();
        return this.apiService
          .acceptAccessRequest(
            payload.param,
            payload.internal,
            payload.requestArray
          )
          .pipe(
            map((data) => {
              this.globalService.loadingSubject.next(false);
              this.userProfileService.clearUserProfile();
              this.router.navigate([AppConstants.routeUrls.accessRequest]);
              return functionalityAction.acceptPendingRequestActionSuccess({
                success: data.status,
              });
            }),
            catchError((error) =>
              of(
                functionalityAction.acceptPendingRequestActionFail({
                  payload: tryNormalizeHttpError(error, this.logger),
                })
              )
            )
          );
      })
    )
  );


  // Effect to rebuild table when admin toggle changes
  updateToggle$ = createEffect(() =>
    this.actions.pipe(
      ofType(functionalityAction.updateToggleAction),
      delay(0),
      switchMap(() => this.userProfileService.getfethedUserProFileData()),
      tap((profileData) => {
        if (profileData && profileData.legalEnties && profileData.userData) {
          this.userProfileEffectsService.createUserProfileTable(
            profileData.legalEnties,
            profileData.userData
          );
        }
      })
    ),
    { dispatch: false }
  );
}
